import { render, staticRenderFns } from "./OpenRateRankingSection.vue?vue&type=template&id=5664ea27&scoped=true&"
import script from "./OpenRateRankingSection.vue?vue&type=script&lang=js&"
export * from "./OpenRateRankingSection.vue?vue&type=script&lang=js&"
import style0 from "./OpenRateRankingSection.vue?vue&type=style&index=0&id=5664ea27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664ea27",
  null
  
)

export default component.exports